import React, { useState, useEffect } from 'react';
import numeral from 'numeral';

const ProductForm = (props) => {
    const [ edit, setEdit ] = useState({
        name:true,
        details:true,
        sku:true,
        category:true,
        image:true,
        length:true,
        width:true,
        height:true,
        weight:true,
        price:true,
        stock:true
    });

    useEffect(() => {
        if(props.values.productName) {
            setEdit({
                ...edit,
                name:false,
                details:false,
                sku:false,
                category:false,
                image:false,
                length:false,
                width:false,
                height:false,
                weight:false,
                price:false,
                stock:false
            })
        }
    }, []);

    const onClickEdit = (field) => {
        if (field === 'category') {
            props.onClickEditCategory()
        }
        setEdit({...edit, [field]:true})
    };

    const filledView = (name, field) => {
        return (
            <div className="d-flex justify-content-between form-group ">
                <b>
                    {name ? name : '-'}
                </b>
                <a onClick={() => onClickEdit(field)}>
                    <i className="fas fa-edit"></i>
                </a>
            </div>
        )
    };

    return (
        <div className={`${ props.className } row mr-0`}>
            <div className="col-4 pr-0">
                <h6 className="pl-3">Gambar</h6>
                <div className="text-center">
                    <img
                        src={props.values.productImage ? props.values.productImage : '/images/no-photo.png'}
                        style={{height:200, width:200}}
                        className="rounded mt-2"
                    />
                    <div className="custom-file mt-2">
                        <input
                            type="file"
                            className="btn-secondary upload-product-image"
                            id="file"
                            accept="image/*"
                            onChange={e => props.onProductImageSelect(e)}
                        />
                        <label htmlFor="file" className="btn-1">Upload Gambar</label>
                    </div>
                </div>
            </div>
            <div className="col-8">
                <div className="form-row mb-2">
                    <div className="form-group input-group-sm col-6 mb-0">
                        <label>Nama Barang </label>
                        {
                            edit.name ?
                                <input
                                    type="text"
                                    onChange={props.handleChange('productName')}
                                    placeholder="Cth: Salmon Sushi / Kaos"
                                    className="form-control"
                                    value={props.values.productName}
                                />
                                :
                                <div>
                                    { filledView(props.values.productName,'name')}
                                </div>
                        }

                    </div>
                    <div className="form-group input-group-sm col-6 mb-0">
                        <label>Kategori Barang </label>
                        {
                            edit.category ?
                                <div className="input-group input-group-sm">
                                    <select
                                        onChange={props.handleChange('productCategory')}
                                        className="custom-select form-control"
                                    >
                                        {
                                            props.categories.map((i,idx) => (
                                                <option
                                                    key={idx}
                                                    value={i}
                                                    className={`${idx === 0 ? "selected":""}`}
                                                >
                                                    {i}
                                                </option>
                                            ))
                                        }
                                    </select>
                                    <div className="input-group-append">
                                        <button
                                            onClick={props.onClickEditCategories}
                                            className="btn btn-outline-primary"
                                            type="button"
                                        >
                                            Edit
                                        </button>
                                    </div>
                                </div>
                                :
                                <div>
                                    { filledView(props.values.productCategory,'category')}
                                </div>
                        }

                    </div>
                </div>

                <div className="form-group mb-2">
                    <label>Detail Barang </label>
                    {
                        edit.details ?
                            <textarea
                                type="textarea"
                                style={{fontSize:'14px'}}
                                onChange={props.handleChange('productDetails')}
                                placeholder="Cth: Salmon only"
                                className="form-control"
                                value={props.values.productDetails}
                            />
                            :
                            <div>
                                { filledView(props.values.productDetails,'details')}
                            </div>
                    }

                </div>

                <div className="form-row mb-2">
                    <div className="form-group input-group-sm col-4 mb-2">
                        <label>SKU Barang </label>
                        {
                            edit.sku ?
                                <input
                                    type="text"
                                    onChange={props.handleChange('productSku')}
                                    placeholder="Cth: XX-Y-XL"
                                    className="form-control"
                                    value={props.values.productSku}
                                />
                                :
                                <div>
                                    { filledView(props.values.productSku,'sku')}
                                </div>
                        }
                    </div>
                    <div className="form-group input-group-sm col-4 mb-2">
                        <label>Harga Barang </label>
                        {
                            edit.price ?
                                <input
                                    type="number"
                                    onChange={props.handleChange('productPrice')}
                                    placeholder="Cth: Rp. 200.000"
                                    className="form-control"
                                    value={props.values.productPrice}
                                />
                                :
                                <div>
                                    { filledView(props.values.productPrice,'price')}
                                </div>
                        }
                    </div>
                    <div className="form-group input-group-sm col-4 mb-2">
                        <label>Stok Barang </label>
                        {
                            edit.stock ?
                                <input
                                    type="number"
                                    onChange={props.handleChange('productStock')}
                                    placeholder="99"
                                    className="form-control"
                                    value={props.values.productStock ? props.values.productStock : '' }
                                />
                                :
                                <div>
                                    { filledView(props.values.productStock,'stock')}
                                </div>
                        }

                    </div>

                </div>

                <div className="form-group input-group-sm mb-0">
                    <label className="mb-0">Dimensi dan Berat Barang</label><br/>
                    <small className="text-muted">Panjang x Lebar x Tinggi dalam Centi Meter dan Berat dalam Gram</small>
                    {
                        edit.length ?
                            <div className="form-row">
                                <div className={`input-group-sm col-2`}>
                                    <input
                                        type="number"
                                        className="form-control"
                                        placeholder="P"
                                        onChange={props.handleChange('productLength')}
                                        value={props.values.productLength ? props.values.productLength : ''}
                                        required
                                    />
                                </div>
                                <div className={`input-group-sm col-2`}>
                                    <input
                                        type="number"
                                        className="form-control"
                                        placeholder="L"
                                        onChange={props.handleChange('productWidth')}
                                        value={props.values.productWidth ? props.values.productWidth : ''}
                                        required
                                    />
                                </div>
                                <div className={`input-group-sm col-2`}>
                                    <input
                                        type="number"
                                        className="form-control"
                                        placeholder="T"
                                        onChange={props.handleChange('productHeight')}
                                        value={props.values.productHeight ? props.values.productHeight : ''}
                                        required
                                    />
                                </div>
                                <div className={`input-group input-group-sm col-6`}>
                                    <input
                                        type="number"
                                        className="form-control"
                                        placeholder="Berat Barang (gram)"
                                        onChange={props.handleChange('productWeight')}
                                        value={props.values.productWeight ? props.values.productWeight : ''}
                                        aria-describedby="weight-addon"
                                        required
                                    />
                                    <div className="input-group-append">
                                        <span className="input-group-text px-1" id="weight-addon">Gram/qty</span>
                                    </div>
                                </div>
                            </div>
                            :
                            <div className="d-flex justify-content-between form-group ">
                                <b>Dimensi: {props.values.productLength}cm x {" "}
                                    {props.values.productWidth}cm x {" "}
                                    {props.values.productHeight}cm
                                    Berat: {props.values.productWeight} gram
                                </b>
                                <a onClick={() => setEdit({...edit, length:true})}>
                                    <i className="fas fa-edit"></i>
                                </a>
                            </div>
                    }
                </div>
            </div>
        </div>
    );
};


export default ProductForm;
